import { errorHandler, instance2 } from "./http";

const userinfoGetAll = async (data:any) =>  { 
    var dataOrg = {
      userId:data
    }; 
    return await instance2.post('/favorites/getById',  dataOrg)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
  }


const favoriteGetAll = async (data:any) =>  {
 
    try{
          const response = await instance2.post('/favorites/create',  data);
              
          if(response.status === 200){
            window.dispatchEvent(new Event('callinterestAll')); 
          } 
          return response;
    }
    catch(error){
      return error;
    }
  }


  export const aoiServices = {
    userinfoGetAll, favoriteGetAll
  }